import { Component, h, Element, Host, Prop } from '@stencil/core';

@Component({
  tag: 'aafp-tag-list-card-gallery-sort',
  shadow: false,
})
export class AafpTagListCardGallerySort {
  @Element() element: HTMLElement;
  @Prop() count = '0';
  @Prop() currentPath = '0';

  onChangeListener = (event: Event) => {
    const select = event.target as HTMLSelectElement;
    const selector = select.value;
    window.location.assign(`${this.currentPath + selector}.html`);
  };

  componentDidLoad() {
    const select = this.element.querySelector('select') as HTMLSelectElement;

    this.init(select);
  }

  init(select: HTMLSelectElement) {
    if (select) {
      select.addEventListener('change', this.onChangeListener);
    }
  }

  render() {
    return (
      <Host class="adl-tag-list-card-gallery-sort__host adl-space__sm__m-b-sm">
        <slot />
        <p class="adl-body adl-font__regular adl-space__sm__m-b-none">{this.count} Total</p>
      </Host>
    );
  }
}
